import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getManageCustomFiltersUrl } from '../../common/urls/index.tsx';
import { CAN_EDIT_BOARD } from '../../model/permission/permission-types.tsx';
import { getPermissionsSelector } from '../../state/selectors/board/board-permissions-selectors.tsx';
import {
	getIsCMPBoard,
	projectKeySelector,
	rapidViewIdSelector,
} from '../../state/selectors/software/software-selectors.tsx';
import type { State } from '../../state/types.tsx';
import CustomFilterFailed from './view.tsx';

type StateProps = {
	canAccessCustomFilterSettings: boolean;
	customFiltersSettingsUrl: string;
};

const mapStateToProps = (state: State): StateProps => {
	const permissions = getPermissionsSelector(state);
	return {
		canAccessCustomFilterSettings: permissions[CAN_EDIT_BOARD] === true && !getIsCMPBoard(state),
		customFiltersSettingsUrl: getManageCustomFiltersUrl(
			projectKeySelector(state),
			rapidViewIdSelector(state),
		),
	};
};

export default connect(mapStateToProps, {})(CustomFilterFailed);
